export const CollabDocRevisionDateFormat = 'MMM d, y, h:mm a';
